import { buildTestIds, getUserInitials } from "application";
import { BoxButtonAuth, UserIcon, theme, UserWrapper } from "ui";
import {
  HeaderUserActionsSection,
  LinkWrapperUser,
  UserEmail,
  UserInformation,
  UserInitials,
  WelcomeContainer,
  WelcomeMessageContainer,
  WelcomeMessageLink,
  WelcomeMessageLinkContainer,
  WelcomeMessageTitle,
  WelcomeWrapper,
  ImageCircle,
  UserName,
  IconWrapper,
} from "./styles";
import { ModalAuthentication } from "../../ModalAuthentication";
import { DropdownUserAuthenticated } from "../../ListCategories/components/DropdownUserAuthenticated";
import { useUserAuthenticationBox } from "./data";

export const UserAuthenticationBox = () => {
  const {
    handleUserMenu,
    isAuthenticated,
    ModalAuthRef,
    handleOpenDropdownUserAuthenticated,
    openLoginModal,
    isOpenedDropdownUser,
    userData,
  } = useUserAuthenticationBox();

  return (
    <HeaderUserActionsSection>
      <LinkWrapperUser
        aria-label="Área de login do usuário"
        {...buildTestIds("link-wrapper-user-desk")}
        onClick={(event) => handleUserMenu(event)}
      >
        {isAuthenticated ? (
          <BoxButtonAuth ref={ModalAuthRef}>
            <UserWrapper
              {...buildTestIds("wrapper-user-authenticated")}
              onClick={handleOpenDropdownUserAuthenticated}
            >
              <IconWrapper {...buildTestIds("icon-wrapper")}>
                <ImageCircle {...buildTestIds("image-circle")}>
                  <UserInitials {...buildTestIds("user-initial")}>
                    {userData?.name ? getUserInitials(userData?.name) : null}
                  </UserInitials>
                </ImageCircle>
              </IconWrapper>
              <UserInformation {...buildTestIds("user-information")}>
                <UserName>{userData?.name}</UserName>
                <UserEmail {...buildTestIds("user-email")}>
                  {userData?.email}
                </UserEmail>
              </UserInformation>
            </UserWrapper>

            {isOpenedDropdownUser && (
              <DropdownUserAuthenticated
                handleCloseDropdownUserAuthenticated={
                  handleOpenDropdownUserAuthenticated
                }
                isOpenedDropdownUser={isOpenedDropdownUser}
              />
            )}
          </BoxButtonAuth>
        ) : (
          <WelcomeContainer
            position="relative"
            alignItems="center"
            gap={theme.space.x2}
            whiteSpace="nowrap"
            {...buildTestIds("user-unaunthenticated-container")}
          >
            <WelcomeWrapper {...buildTestIds("welcome-wrapper")}>
              <IconWrapper {...buildTestIds("icon-wrapper")}>
                <UserIcon
                  width={24}
                  height={24}
                  color={theme.colors.neutral.white}
                />
              </IconWrapper>
              <WelcomeMessageContainer {...buildTestIds("instruction-message")}>
                <WelcomeMessageTitle {...buildTestIds("welcome-message-title")}>
                  Bem vindo!
                </WelcomeMessageTitle>
                <WelcomeMessageLinkContainer
                  {...buildTestIds("welcome-message-link-container")}
                >
                  <WelcomeMessageLink
                    onClick={(e) => openLoginModal(e, "/login")}
                    {...buildTestIds("welcome-message-link-login")}
                  >
                    Entre
                  </WelcomeMessageLink>
                  <WelcomeMessageLink
                    {...buildTestIds("welcome-message-link-register")}
                    onClick={(e) => openLoginModal(e, "/cadastro")}
                  >
                    ou cadastre-se
                  </WelcomeMessageLink>
                </WelcomeMessageLinkContainer>
              </WelcomeMessageContainer>
            </WelcomeWrapper>
            <ModalAuthentication {...buildTestIds("modal-authentication")} />
          </WelcomeContainer>
        )}
      </LinkWrapperUser>
    </HeaderUserActionsSection>
  );
};
